import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper, 
  Alert, 
  CircularProgress,
  Divider,
  Chip,
  useTheme,
  useMediaQuery,
  Fade,
  Slide,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Container,
  LinearProgress,
  IconButton,
  Tooltip
} from '@mui/material';
import { 
  CheckCircle, 
  Error, 
  AccessTime, 
  Receipt,
  Home,
  ShoppingCart,
  Payment,
  Refresh,
  CheckCircleOutline,
  Restaurant,
  LocalShipping,
  Storefront,
  Schedule,
  Notifications,
  Phone,
  Email,
  Share,
  Print,
  Download,
  Timeline,
  Star,
  Security,
  CreditCard,
  QrCode
} from '@mui/icons-material';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { PageSkeleton } from '../../components/common/SkeletonLoader';
import { orderService } from '../../services/orderService';
import { restaurantService } from '../../services/restaurantService';

const PaymentResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { clearCart,loadRestaurantData } = useRestaurant();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [paymentStatus, setPaymentStatus] = useState('success');
  const [onlinePayOrder,setOnlinePayOrder] = useState({})
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkingPayment, setCheckingPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("")
  const [paymentCheckCount, setPaymentCheckCount] = useState(0);
  const [restaurantData,setRestaurantData] = useState({});
  const maxPaymentChecks = 10; // Maximum number of payment status checks

  console.log("Order Details => ", orderDetails);

  // Function to check payment status
  const checkPaymentStatus = async (orderId) => {
    if (!orderId || paymentCheckCount >= maxPaymentChecks) return;

    setCheckingPayment(true);
    try {
      const paymentData = await orderService.getPaymentStatus(orderId);
      console.log('Payment status check:', paymentData);

      if (paymentData.payment_status === 'paid' && paymentData.has_payment_record) {
        setPaymentStatus('success');
        setOrderDetails(prev => ({
          ...prev,
          payment_status: 'paid',
          payment_record: paymentData.payment_record
        }));
        setCheckingPayment(false);

        // Call confirm payment API to ensure payment data is saved
        try {
          const confirmData = {
            provider_payment_id: paymentData.payment_record?.provider_payment_id || `webhook_${orderId}_${Date.now()}`,
            payment_method: 'pay_online',
            amount: paymentData.payment_record?.amount || 0,
            currency: 'SGD',
            payment_metadata: {
              order_id: orderId,
              order_number: paymentData.order_number,
              payment_type: 'webhook_confirmed',
              confirmed_at: new Date().toISOString(),
              webhook_data: paymentData.payment_record
            }
          };

          await orderService.confirmPayment(orderId, confirmData);
          console.log('Payment confirmed via API after webhook');
        } catch (error) {
          console.error('Failed to confirm payment via API:', error);
          // Don't fail the entire flow if confirmation fails
        }

        return true; // Payment confirmed
      } else if (paymentData.payment_status === 'failed') {
        setPaymentStatus('failed');
        setCheckingPayment(false);
        return true; // Payment failed
      }

      // Payment still pending, check again after delay
      setPaymentCheckCount(prev => prev + 1);
      // TEMPORARILY DISABLED: setTimeout(() => checkPaymentStatus(orderId), 3000); // Check every 3 seconds
      console.log('Payment status polling temporarily disabled to prevent repeated API calls');
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentCheckCount(prev => prev + 1);
      if (paymentCheckCount < maxPaymentChecks - 1) {
        // TEMPORARILY DISABLED: setTimeout(() => checkPaymentStatus(orderId), 5000); // Retry after 5 seconds on error
        console.log('Payment status polling temporarily disabled to prevent repeated API calls');
      }
    } finally {
      setCheckingPayment(false);
    }
    return false;
  };

  console.log("all data => ", location.state);
  console.log("payment Status => ", paymentStatus);
  // conso le.log("data here => ", location.state.order.payment_method)
  useEffect(() => {
    // Get payment status from URL params or location state
    let status = searchParams.get('status') || location.state?.status || 'success';
    if(searchParams.get('status') === 'completed') status = 'success';
    let order = location.state?.order;
    let p = location.state?.order?.payment_method;
    setPaymentMethod(p);
    try{
      async function fetchRestaurantData(){
        const response = await restaurantService.getPublicRestaurantData();
        console.log("Restaurant Data => ", response);
        setRestaurantData(response)
      }
      fetchRestaurantData()
    }
    catch(error){
      console.error("Error on Getting Restaurant Data => ",error);
    }
    // console.log("Payment_method == > ",payment_method );

    // Check for mock payment
    const isMockPayment = searchParams.get('mock') === 'true';

    // Check for pending order in sessionStorage (for HitPay redirects)
    if (!order && status === 'success') {
      const pendingOrder = sessionStorage.getItem('pendingOrder');
      if (pendingOrder) {
        try {
          order = JSON.parse(pendingOrder);
          setOnlinePayOrder(order);
          // Clear the pending order from sessionStorage
          sessionStorage.removeItem('pendingOrder');
        } catch (error) {
          console.error('Error parsing pending order:', error);
        }
      }
    }
    console.log("At Checkout Status => ", status);
    
    setPaymentStatus(status);
    setOrderDetails(order);

    // If this is a HitPay redirect and we have an order ID, check payment status
    const orderId = searchParams.get('order_id') || order?.id;
    if (orderId && !isMockPayment && status === 'success') {
      // TEMPORARILY DISABLED: Start checking payment status
      // setTimeout(() => checkPaymentStatus(orderId), 2000); // Start checking after 2 seconds
      console.log('Payment status polling temporarily disabled to prevent repeated API calls');
    }

    // Clear cart on successful payment
    if (status === 'success') {
      clearCart && clearCart();
    }

    setLoading(false);
  }, [searchParams, location.state, clearCart]);

  console.log("Order is => " , orderDetails);

  console.log("Payment Method => ", paymentMethod)

  const getStatusIcon = () => {
    switch (paymentStatus) {
      case 'success':
        return (
          <Box sx={{
            position: 'relative',
            display: 'inline-block',
            animation: 'pulse 2s ease-in-out infinite',
            padding: '12px'
          }}>
            <Avatar sx={{
              width: 150,
              height: 150,
              bgcolor: 'success.main',
              boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
              animation: 'bounce 1s ease-in-out'
            }}>
              <CheckCircle sx={{ fontSize: '150px !important' }} />
            </Avatar>
            {/* <Box sx={{ 
              position: 'absolute',
              top: -10,
              right: -10,
              width: 50,
              height: 50,
              borderRadius: '50%',
              bgcolor: 'success.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'scaleIn 0.5s ease-out 0.5s both'
            }}>
              <CheckCircleOutline sx={{ fontSize: 30, color: 'white' }} />
            </Box> */}
          </Box>
        );
      case 'pending':
        return (
          <Avatar sx={{
            width: 150,
            height: 150,
            bgcolor: 'warning.main',
            boxShadow: '0 8px 32px rgba(255, 152, 0, 0.3)',
            animation: 'rotate 2s linear infinite'
          }}>
            <AccessTime sx={{ fontSize: 80 }} />
          </Avatar>
        );
      case 'failed':
        return (
          <Avatar sx={{
            width: 150,
            height: 150,
            bgcolor: 'error.main',
            boxShadow: '0 8px 32px rgba(244, 67, 54, 0.3)'
          }}>
            <Error sx={{ fontSize: 80 }} />
          </Avatar>
        );
      default:
        return (
          <Avatar sx={{
            width: 150,
            height: 150,
            bgcolor: 'primary.main',
            boxShadow: '0 8px 32px rgba(25, 118, 210, 0.3)'
          }}>
            <Receipt sx={{ fontSize: 80 }} />
          </Avatar>
        );
    }
  };

  const getStatusTitle = () => {
    switch (paymentStatus) {
      case 'success':
        return paymentMethod === "cash_on_delivery" ? "Order Placed Successfully" : 'Payment Successful! 🎉';
      case 'pending':
        return paymentMethod === "cash_on_delivery" ? "Order Placement is Processing" : 'Payment Processing...';
      case 'failed':
        return paymentMethod === "cash_on_delivery" ? "Order Placement Failed" : 'Payment Failed';
      default:
        return 'Payment Status';
    }
  };

  const getStatusMessage = () => {
    if (checkingPayment) {
      return 'We are verifying your payment with our payment provider. This usually takes a few moments. Please wait...';
    }

    switch (paymentStatus) {
      case 'success':
        return paymentMethod === "cash_on_delivery" ? "Your order has been confirmed and sent to our kitchen. We will start preparing your delicious meal right away." : 'Your payment has been processed successfully! Your order has been confirmed and sent to our kitchen. We will start preparing your delicious meal right away.';
      case 'pending':
        return paymentMethod === "cash_on_delivery" ? "You will receive a confirmation once it\'s completed." : 'Your payment is being processed. You will receive a confirmation once it\'s completed.';
      case 'failed':
        return paymentMethod === "cash_on_delivery" ? "Please try again or contact support for assistance." : 'Unfortunately, your payment could not be processed. Please try again or contact support for assistance.';
      default:
        return 'Your order has been received.';
    }
  };

  const getStatusColor = () => {
    if (checkingPayment) {
      return 'info';
    }

    switch (paymentStatus) {
      case 'success':
        return 'success';
      case 'pending':
        return 'warning';
      case 'failed':
        return 'error';
      default:
        return 'info';
    }
  };

  const getOrderTypeIcon = (orderType) => {
    switch (orderType?.toLowerCase()) {
      case 'delivery':
        return <LocalShipping />;
      case 'takeaway':
        return <Storefront />;
      case 'dine_in':
        return <Restaurant />;
      default:
        return <Receipt />;
    }
  };

  const getOrderSteps = () => {
    const steps = [
      { label: 'Order Placed', completed: true },
      { label: 'Payment Processed', completed: paymentStatus === 'success' },
      { label: 'Kitchen Preparing', completed: paymentStatus === 'success' },
      { label: orderDetails?.order_type === 'delivery' ? 'Out for Delivery' : 'Ready for Pickup', completed: false }
    ];
    return steps;
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress size={60} sx={{ mb: 2 }} />
            <Typography variant="h6" color="text.secondary">Processing Payment...</Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: 'background.default',
      background: paymentStatus === 'success'
        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        : paymentStatus === 'failed'
          ? 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)'
          : 'linear-gradient(135deg, #feca57 0%, #ff9ff3 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.1,
        backgroundImage: 'radial-gradient(circle at 25% 25%, white 2px, transparent 0), radial-gradient(circle at 75% 75%, white 2px, transparent 0)',
        backgroundSize: '50px 50px'
      }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <Box sx={{
          textAlign: 'center',
          py: 4,
          color: 'white'
        }}>
          <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
            {getStatusTitle()}
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
            Order Status Update
          </Typography>
        </Box>

        <Box sx={{
          maxWidth: { xs: '100%', sm: 800 },
          mx: 'auto',
          mb: 4
        }}>
          <Fade in={true} timeout={800}>
            <Paper elevation={24} sx={{
              borderRadius: 4,
              overflow: 'hidden',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              {/* Status Section */}
              <Box sx={{
                textAlign: 'center',
                p: { xs: 3, sm: 4 },
                background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)'
              }}>
                <Slide direction="up" in={true} timeout={1000}>
                  <Box sx={{ mb: 3 }}>
                    {checkingPayment ? (
                      <Box sx={{ position: 'relative' }}>
                        <CircularProgress
                          size={150}
                          thickness={4}
                          sx={{
                            color: 'primary.main',
                            animation: 'pulse 2s ease-in-out infinite'
                          }}
                        />
                        <Payment
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: 60,
                            color: 'primary.main'
                          }}
                        />
                      </Box>
                    ) : (
                      getStatusIcon()
                    )}
                  </Box>
                </Slide>

                <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700} gutterBottom color={`${getStatusColor()}.main`}>
                  {getStatusTitle()}
                </Typography>

                <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6, maxWidth: 600, mx: 'auto' }}>
                  {getStatusMessage()}
                </Typography>

                {/* Mock Payment Indicator */}
                {searchParams.get('mock') === 'true' && (
                  <Alert severity="info" sx={{ mb: 3, textAlign: 'left', borderRadius: 2 }}>
                    <Typography variant="body2" fontWeight={600}>Development Mode</Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This is a mock payment for testing purposes. In production, this would be processed through HitPay.
                    </Typography>
                  </Alert>
                )}

                {/* Payment Checking Status */}
                {checkingPayment && (
                  <Alert
                    severity="info"
                    sx={{
                      mb: 3,
                      textAlign: 'left',
                      borderRadius: 2
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box>
                        <Typography variant="body2" fontWeight={600}>
                          🔄 Verifying Payment
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          Checking with payment provider... ({paymentCheckCount + 1}/{maxPaymentChecks})
                        </Typography>
                      </Box>
                      <CircularProgress size={24} />
                    </Box>
                  </Alert>
                )}
              </Box>

              {/* Order Details Section */}
              {orderDetails && (
                <>
                  <Divider />
                  <Box sx={{ p: { xs: 3, sm: 4 } }}>
                    <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Receipt color="primary" sx={{ fontSize: 32 }} />
                      Order Details
                    </Typography>

                    <Grid container spacing={3}>
                      {/* Order Info */}
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined" sx={{ height: '100%' }}>
                          <CardContent>
                            <Typography variant="h6" gutterBottom color="primary" fontWeight={600}>
                              Order Information
                            </Typography>
                            <List dense>
                              <ListItem>
                                <ListItemIcon>
                                  <Receipt color="primary" sx={{ fontSize: 28 }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary="Order Number"
                                  secondary={orderDetails.order_number}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <Restaurant color="primary" sx={{ fontSize: 28 }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary="Customer Name"
                                  secondary={orderDetails.customer_name || 'Guest Customer'}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <Phone color="primary" sx={{ fontSize: 28 }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary="Phone Number"
                                  secondary={orderDetails.customer_phone || 'N/A'}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  {React.cloneElement(getOrderTypeIcon(orderDetails.order_type), { sx: { fontSize: 28 } })}
                                </ListItemIcon>
                                <ListItemText
                                  primary="Order Type"
                                  secondary={
                                    <Chip
                                      label={orderDetails.order_type?.toUpperCase()}
                                      size="small"
                                      color="primary"
                                      variant="outlined"
                                    />
                                  }
                                />
                              </ListItem>
                            </List>
                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Payment Info */}
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined" sx={{ height: '100%' }}>
                          <CardContent>
                            <Typography variant="h6" gutterBottom color="primary" fontWeight={600}>
                              Payment Information
                            </Typography>
                            <List dense>
                              <ListItem>
                                <ListItemIcon>
                                  <CreditCard color="primary" sx={{ fontSize: 28 }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary="Total Amount"
                                  secondary={
                                    <Typography variant="h6" color="success.main" fontWeight={600}>
                                      S${orderDetails.total_amount?.toFixed(2)}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <Security color="primary" sx={{ fontSize: 28 }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary="Payment Status"
                                  secondary={
                                    <Chip
                                      label={orderDetails.payment_status?.toUpperCase() || 'PAID'}
                                      size="small"
                                      color="success"
                                      variant="filled"
                                      icon={<CheckCircle />}
                                    />
                                  }
                                />
                              </ListItem>
                              {orderDetails.delivery_address && (
                                <ListItem>
                                  <ListItemIcon>
                                    <LocalShipping color="primary" sx={{ fontSize: 28 }} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary="Delivery Address"
                                    secondary={orderDetails.delivery_address}
                                  />
                                </ListItem>
                              )}
                            </List>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>

                    {/* Success Message */}
                    {orderDetails.payment_status === 'paid' && (
                      <Alert severity="success" sx={{ mt: 3, borderRadius: 2 }}>
                        <Typography variant="body2" fontWeight={600}>
                          🎉 Payment Successful!
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Your payment has been processed successfully. You will receive an SMS confirmation shortly with your order details and delivery token number.
                        </Typography>
                      </Alert>
                    )}
                  </Box>
                </>
              )}

              {/* Order Progress Steps */}
              {paymentStatus === 'success' && (
                <>
                  <Divider />
                  <Box sx={{ p: { xs: 3, sm: 4 } }}>
                    <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Timeline color="primary" sx={{ fontSize: 32 }} />
                      Order Progress
                    </Typography>
                    <Stepper orientation={isMobile ? "vertical" : "horizontal"} activeStep={paymentStatus === 'success' ? 2 : 1}>
                      {getOrderSteps().map((step, index) => (
                        <Step key={step.label} completed={step.completed}>
                          <StepLabel>{step.label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </>
              )}

              {/* What Happens Next */}
              <Box sx={{ p: { xs: 3, sm: 4 }, bgcolor: 'grey.50' }}>
                <Typography variant="h6" gutterBottom fontWeight={600} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Schedule color="primary" sx={{ fontSize: 28 }} />
                  What happens next?
                </Typography>
                {paymentStatus === 'success' && (
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircle color="success" sx={{ fontSize: 28 }} />
                      </ListItemIcon>
                      <ListItemText primary="Your order has been sent to our kitchen team" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <Restaurant color="success" sx={{ fontSize: 28 }} />
                      </ListItemIcon>
                      <ListItemText primary="Our chefs will start preparing your delicious meal" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <Notifications color="success" sx={{ fontSize: 28 }} />
                      </ListItemIcon>
                      <ListItemText primary="You'll receive SMS/email updates on your order progress" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        {orderDetails?.order_type === 'delivery' ?
                          <LocalShipping color="success" sx={{ fontSize: 28 }} /> :
                          <Storefront color="success" sx={{ fontSize: 28 }} />
                        }
                      </ListItemIcon>
                      <ListItemText
                        primary={orderDetails?.order_type === 'delivery'
                          ? 'Our delivery team will bring your order to your doorstep'
                          : 'You can pick up your order when it\'s ready'
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <AccessTime color="success" sx={{ fontSize: 28 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={`Estimated time: ${orderDetails?.order_type === 'delivery' ? '30-45 minutes' : '15-25 minutes'}`}
                      />
                    </ListItem>
                  </List>
                )}
                {paymentStatus === 'pending' && (
                  <Typography variant="body2" color="text.secondary">
                    Your payment is being verified. This usually takes a few minutes. You'll receive an email confirmation once the payment is completed.
                  </Typography>
                )}
                {paymentStatus === 'failed' && (
                  <Typography variant="body2" color="text.secondary">
                    If you continue to experience issues, please contact our support team or try using a different payment method.
                  </Typography>
                )}
              </Box>

              {/* Action Buttons */}
              <Box sx={{
                p: { xs: 3, sm: 4 },
                display: 'flex',
                gap: 2,
                justifyContent: 'center',
                flexWrap: 'wrap',
                flexDirection: { xs: 'column', sm: 'row' }
              }}>
                <Button
                  variant="contained"
                  size="large"
                  startIcon={<Home />}
                  onClick={() => {
                    localStorage.removeItem('cart_items');
                    navigate('/')
                  }}
                  sx={{
                    borderRadius: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    minWidth: 160,
                    py: 1.5,
                    background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #5a6fd8 0%, #6a4190 100%)',
                    }
                  }}
                >
                  Back to Home
                </Button>

                {checkingPayment && (
                  <Button
                    variant="outlined"
                    size="large"
                    startIcon={<Refresh />}
                    onClick={() => {
                      const orderId = searchParams.get('order_id') || orderDetails?.id;
                      if (orderId) {
                        setPaymentCheckCount(0);
                        checkPaymentStatus(orderId);
                      }
                    }}
                    disabled={checkingPayment}
                    sx={{
                      borderRadius: 3,
                      textTransform: 'none',
                      fontWeight: 600,
                      minWidth: 160,
                      py: 1.5
                    }}
                  >
                    Refresh Status
                  </Button>
                )}

                {paymentStatus === 'failed' && (
                  <Button
                    variant="outlined"
                    size="large"
                    startIcon={<ShoppingCart />}
                    onClick={() => navigate('/checkout')}
                    sx={{
                      borderRadius: 3,
                      textTransform: 'none',
                      fontWeight: 600,
                      minWidth: 160,
                      py: 1.5
                    }}
                  >
                    Try Again
                  </Button>
                )}

                {paymentStatus === 'success' && (
                  <Button
                    variant="outlined"
                    size="large"
                    startIcon={<Share />}
                    onClick={() => {
                      if (orderDetails?.unique_string ) {
                        navigate(`/order/details/${orderDetails.unique_string}`)
                      }
                      else if(onlinePayOrder?.unique_string){
                         navigate(`/order/details/${onlinePayOrder?.unique_string}`)
                      } 
                      else {
                        console.warn("unique_string not available yet")
                      }
                    }}

                    //   onClick={() => navigate(`/order/details/${orderDetails?.unique_string}`)
                    //   //   {
                    //   //   if (navigator.share) {
                    //   //     navigator.share({
                    //   //       title: 'Order Confirmation',
                    //   //       text: `My order ${orderDetails?.order_number} has been confirmed!`,
                    //   //       url: window.location.href
                    //   //     });
                    //   //   }
                    //   // }
                    // }
                    sx={{
                      borderRadius: 3,
                      textTransform: 'none',
                      fontWeight: 600,
                      minWidth: 160,
                      py: 1.5
                    }}
                  >
                    Share
                  </Button>
                )}
              </Box>

              {/* Support Information */}
              <Box sx={{
                p: { xs: 3, sm: 4 },
                bgcolor: 'primary.main',
                color: 'white',
                textAlign: 'center'
              }}>
                <Typography variant="h6" gutterBottom fontWeight={600}>
                  Need help?
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
                  Contact our support team for any questions or concerns
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Email sx={{ fontSize: 24 }} />
                    <Typography variant="body2">{restaurantData?.email}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Phone sx={{ fontSize: 24 }} />
                    <Typography variant="body2">+{restaurantData?.phone}</Typography>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Fade>
        </Box>
      </Container>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
        
        @keyframes scaleIn {
          0% { transform: scale(0); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </Box>
  );
};

export default PaymentResultPage;